// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateStatusElectronicInvoiceMutationVariables = Types.Exact<{
  invoiceId: Types.Scalars['Int']['input'];
}>;


export type UpdateStatusElectronicInvoiceMutationResult = { __typename?: 'Mutation', updateStatusElectronicInvoice: Types.EInvoiceStatusEnumDto | null };

export const UpdateStatusElectronicInvoiceGql = gql`
    mutation UpdateStatusElectronicInvoice($invoiceId: Int!) {
  updateStatusElectronicInvoice(invoiceId: $invoiceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStatusElectronicInvoiceInjectable extends Apollo.Mutation<UpdateStatusElectronicInvoiceMutationResult, UpdateStatusElectronicInvoiceMutationVariables> {
    override document = UpdateStatusElectronicInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */